import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { translate } from "react-admin";
import Dropzone from "react-dropzone";
import { parse } from "papaparse/papaparse.min";
import axios from "axios";
import BulkImportStatus from "./BulkImportStatus";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  }
});

// Set authorization globally
axios.defaults.headers.post["Authorization"] = "Bearer " + localStorage.getItem("token");

// error dialog transition
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class BulkImport extends React.Component {
  /**
   * @return {boolean}
   */
  constructor(props) {
    super(props);
    this.state = {
      imports: [],
      error: null,
      errorDialogOpen: false,
      doneDialogOpen: false,
      csvInProgress: false,
      progressPercent: 0
    };
    let { translate } = this.props;
    let { campaignId } = this.props.match.params;

    if (!isFinite(String(campaignId)) || campaignId < 1) {
      alert(translate("app.bulk_import.messages.invalid_campaign_id"));
      return false;
    }
  }

  createData = (line, code, description, status) => {
    return { line, code, description, status };
  };

  renderDropZone() {
    const { classes, translate } = this.props;
    const { csvInProgress } = this.state;
    return (<Dropzone onDrop={this.onDrop} translate={translate} campaign={this.props.match.params}
                      onClick={evt => evt.preventDefault()}>
      {({ getRootProps, getInputProps, open }) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <Button
            disabled={csvInProgress}
            variant="raised"
            color="primary"
            className={classes.button}
            onClick={() => open()}
            style={{ marginTop: "1rem" }}
          >
            {translate("app.bulk_import.button")}
          </Button>
        </div>
      )}
    </Dropzone>);
  };

  onDrop = (files) => {
    // CSV processing in progress
    this.setState({
      csvInProgress: true
    });

    const { translate } = this.props;
    let campaign = this.props.match.params;
    let campaignId = campaign.campaignId;
    let size = null;
    let csvRowNum = 0;
    let self = this;

    return files.forEach(file => {
      // Reset imports
      self.setState({
        imports: [],
        error: null
      });

      // Set file size
      size = file.size;

      // Reset csv row
      csvRowNum = 0;

      parse(file, {
        header: true,
        step: function(results, parser) {
          // Do nothing on empty lines
          if (Object.keys(results.data)[0] === undefined || Object.keys(results.data)[1] === undefined) {
            return;
          }

          // Set persent
          let progress = results.meta.cursor;
          let progressCsvCursor = Math.round(progress / size * 100);

          // Check if the CSV header is not respected
          let headerError = null;
          if (results.data.code === undefined) {
            headerError = { expected: "code", given: Object.keys(results.data)[0] };
          }
          if (results.data.description === undefined) {
            headerError = { expected: "description", given: Object.keys(results.data)[1] };
          }
          if (headerError) {
            self.setState({
              error: translate("app.bulk_import.messages.wrong_header", headerError),
              errorDialogOpen: true
            });
            parser.abort();
            return false;
          }

          const coupon = {
            campaign: "/api/campaigns/" + campaignId,
            code: results.data.code,
            description: results.data.description
          };

          // ignore empty coupons
          if (!coupon.code) {
            csvRowNum++;
            self.updateProcessPercent(progressCsvCursor);
            self.setState({
              imports: [...self.state.imports, self.createData(csvRowNum, coupon.code, coupon.description, translate("app.bulk_import.messages.wrong_coupon_code"))]
            });
          } else {
            axios
              .post(process.env.REACT_APP_API_ENTRYPOINT + "/coupons", coupon)
              .then(res => {
                csvRowNum++;
                self.updateProcessPercent(progressCsvCursor);
                self.setState({
                  imports: [...self.state.imports, self.createData(csvRowNum, coupon.code, coupon.description, translate("app.bulk_import.messages.success_import"))]
                });
              })
              .catch(error => {
                csvRowNum++;
                self.updateProcessPercent(progressCsvCursor);
                self.setState({
                  imports: [...self.state.imports, self.createData(csvRowNum, coupon.code, coupon.description, error.response.data["hydra:description"])]
                });
              });
          }
        }
      });
    });
  };

  // See the progress of the calls
  updateProcessPercent = (progressCsvCursor) => {
    // fix issue with non async calls
    if (progressCsvCursor > this.state.progressPercent) {
      this.setState({ progressPercent: progressCsvCursor });
    }

    // set to done
    if (this.state.progressPercent >= 100) {
      this.setState({ csvInProgress: false, doneDialogOpen: true });
    }
  };

  // Render dialog error
  renderDone() {
    const { doneDialogOpen } = this.state;
    const { translate } = this.props;

    return (<Dialog
      open={doneDialogOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={this.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {translate("app.bulk_import.messages.done_processing")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {translate("app.bulk_import.messages.done_processing_description")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleClose} color="primary">
          {translate("app.bulk_import.ok")}
        </Button>
      </DialogActions>
    </Dialog>);
  }

  // Closing the error dialog
  handleClose = () => {
    this.setState({ errorDialogOpen: false, doneDialogOpen: false, csvInProgress: false });
  };

  // Render dialog error
  renderError() {
    const { error, errorDialogOpen } = this.state;
    const { translate } = this.props;

    return (<Dialog
      open={errorDialogOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={this.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {translate("app.bulk_import.messages.wrong_header_title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {error}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleClose} color="primary">
          {translate("app.bulk_import.ok")}
        </Button>
      </DialogActions>
    </Dialog>);
  }

  render() {
    const { imports, error, progressPercent } = this.state;
    const { translate, classes } = this.props;
    const { campaignId } = this.props.match.params;

    return (
      <div className={classes.root}>
        <Card>
          <CardContent>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <Typography variant="headline" component="h2">
                  {translate("app.bulk_import.title", { campaignId: campaignId })}
                </Typography>
                <Typography component="p">
                  {translate("app.bulk_import.subtitle")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={24}>
              <Grid item xs={12} md={3}>
                <Typography component="h2">
                  {translate("app.bulk_import.example")}
                </Typography>
                <Typography component="code" variant="caption" color="primary">
                  <code>"code","description"</code>
                </Typography>
                <Typography component="code" variant="caption" color="primary">
                  <code>0001,"10% off your next purchase"</code>
                </Typography>
                <Typography component="code" variant="caption" color="primary">
                  <code>0002,"10% off your next purchase"</code>
                </Typography>
                <Typography component="code" variant="caption" color="primary">
                  <code>0003,"10% off your next purchase"</code>
                </Typography>
                {this.renderDropZone()}
              </Grid>
              <Grid item xs={12} md={9}>
                {error ? this.renderError() : <BulkImportStatus imports={imports} progressPercent={progressPercent}/>}
              </Grid>
              <Grid item xs={12} md={9}>
                {this.renderDone()}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

BulkImport.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(translate(BulkImport));
